// Utility functions for converting between content formats

/**
 * Converts plain text ingredients (one per line) to HTML paragraph format
 * @param ingredientsText - Multi-line string with one ingredient per line
 * @returns HTML string with each line wrapped in <p> tags
 */
export function ingredientsTextToHTML(ingredientsText: string): string {
  return ingredientsText
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line) => `<p>${line}</p>`)
    .join('\n');
}

/**
 * Converts HTML content back to plain text
 * @param htmlContent - HTML content with paragraph tags
 * @returns Plain text with one ingredient per line
 */
export function htmlToIngredientsText(htmlContent: string): string {
  return htmlContent.replace(/<p>/g, '').replace(/<\/p>/g, '\n').trim();
}
